import LessonInfo, { LessonInfoProps as Props } from './LessonInfo';

export type LessonInfoProps = Props;

export default LessonInfo;
